module Meevo.Plugins.SystemToolbox {
    export class SelectMerchantAccountsModalController {
        public isSubmitted: boolean = false;

        static $inject = [
            'meevo.components.modal.ModalService',
            'multiLocationList'
        ];

        constructor(
            private modalService: Meevo.Components.Modal.IModalService,
            public multiLocationList: any
        ) {
            for (const location of this.multiLocationList) {
                location.meevoPayMerchantAccounts = _(location.meevoPayMerchantAccounts).sortBy('displayName');
            }
        }

        private isValid(): boolean {
            return _(this.multiLocationList).all(location => location.selectedMerchantAccountId);
        }

        continue() {
            this.isSubmitted = true;

            if (!this.isValid()) {
                return;
            }

            const selectedMerchantAccounts = {};
            for (const location of this.multiLocationList) {
                selectedMerchantAccounts[location.locationId] = location.selectedMerchantAccountId;
            }

            this.close(selectedMerchantAccounts);
        }

        close(response) {
            this.modalService.hideWithResponse(response);
        }

        cancel() {
            this.close(null);
        }
    }

    angular.module("meevo.plugins.systemToolbox")
        .controller("meevo.plugins.systemToolbox.SelectMerchantAccountsModalController", SelectMerchantAccountsModalController);
}
